import type { ReactNode } from "react";
import Hamburger from "@/components/Hamburger";

interface Props {
  title: string;
  icon?: ReactNode;
  titleAfter?: ReactNode;
  actions?: ReactNode;
}

export default function PageHeader({ title, icon, titleAfter, actions }: Props) {
  return (
    <div className="flex items-center gap-2 px-5 md:px-7 py-6 md:py-8 min-w-0">
      <Hamburger />
      <h2 className="flex items-center gap-2 text-xl md:text-2xl font-light text-gray-900 dark:text-white flex-1 min-w-0">
        {icon}
        <span className="truncate">{title}</span>
        {titleAfter}
      </h2>
      {actions && <div className="ml-auto flex items-center gap-1 flex-shrink-0">{actions}</div>}
    </div>
  );
}
